module.exports = __webpack_public_path__ + "img/giftcards.059f000.svg";